import leftmenu from './leftmenu'
import topmenu from './topmenu'

export default {
  leftmenu,
  topmenu
}
